import {jwtDecode} from "jwt-decode";

const AUTH_KEY = 'auth_key';
const LOCAL_STORAGE = 'ORBCOMM_STORAGE';
const PREF_KEY = '_pso537br';

export const setToLocalStorage = (key, value) => localStorage.setItem(key, value);
export const getFromLocalStorage = (key) => localStorage.getItem(key);
export const removeFromLocalStorage = (key) => localStorage.removeItem(key)
export const getFromLStorage = key => !!getLocalStorage() ? getLocalStorage()[key] : null;

export const getLocalStorage = () => !!window.localStorage[LOCAL_STORAGE] ? JSON.parse(window.localStorage[LOCAL_STORAGE]) : {};
export const setLocalStorage = (key, value) => window.localStorage[LOCAL_STORAGE] = JSON.stringify(Object.assign(getLocalStorage(), { [key]: value }));
export const getFromStorage = key => !!getLocalStorage() ? getLocalStorage()[key] : null;

export const token = {
    get: () => getFromLocalStorage(AUTH_KEY),
    set: (token) => setToLocalStorage(AUTH_KEY, token),
    remove: () => removeFromLocalStorage(AUTH_KEY),
    getDecoded: () => {
        try {
          const token = getFromLocalStorage(AUTH_KEY);
          return token ? jwtDecode(token) : null;
        } catch (err) {
          console.error('Error decoding token:', err);
          return null;
        }
      },
}

export const preferences = {
  get: () => JSON.parse(getFromLStorage(PREF_KEY) || '{}'),
  set: obj => {
    // console.trace(JSON.parse(getFromLocalStorage(PREF_KEY) || '{}'), obj);
    // console.log(Object.assign(JSON.parse(getFromLocalStorage(PREF_KEY) || '{}'), obj));
    setLocalStorage(PREF_KEY, JSON.stringify(Object.assign(JSON.parse(getFromLocalStorage(PREF_KEY) || '{}'), obj)))
  }
};
